import { useState } from "react";
import { dateOf } from "@bd/sim";
import { Icon, Sheet } from "@bd/ui-kit";
import { txLine, useGame } from "../store";
import { t, tdate } from "../i18n";

const FIRST = 6;

/** Online: what happened while the quarter played out. Problems and good news first; the rest behind "Show all". */
export function QuarterReport() {
  const o = useGame((s) => s.online);
  const game = useGame((s) => s.game);
  const set = useGame((s) => s.set);
  const [all, setAll] = useState(false);
  if (!o?.report || !game) return null;
  const color = { good: "var(--green)", bad: "var(--bad)", info: "var(--teal)", warn: "var(--warn)" };
  const rank = { warn: 0, bad: 0, good: 1, info: 2 };
  const lines = [...o.report.lines].sort((a, b) => rank[a.tone] - rank[b.tone]);
  const shown = all ? lines : lines.slice(0, FIRST);
  return (
    <Sheet title={t("Now {date}", { date: tdate(dateOf(game.week).label) })} onClose={() => set({ screen: null })} testId="quarter-report"
      footer={<button className="btn primary" onClick={() => set({ screen: null })} data-testid="report-done"><Icon name="play" size={16} />{t("Play on")}</button>}>
      <div className="stack" style={{ gap: 8 }}>
        {lines.length === 0 && <span className="muted">{t("A quiet quarter.")}</span>}
        {shown.map((l, i) => (
          <div key={i} className="row" style={{ alignItems: "flex-start", gap: 10 }}>
            <span className="dot" style={{ width: 10, height: 10, borderRadius: 5, marginTop: 6, flex: "none", background: color[l.tone] }} />
            <span>{txLine(l.text)}</span>
          </div>
        ))}
        {!all && lines.length > FIRST && (
          <button className="btn small ghost" style={{ alignSelf: "flex-start" }} onClick={() => setAll(true)} data-testid="report-all">{t("Show all ({n})", { n: lines.length })}</button>
        )}
      </div>
    </Sheet>
  );
}
